<template>
  <b-col>
    <b-button
        ref="button"
        :active="false"
        :data-test-path="dataTestPath ?  dataTestPath : primaryDataTestPath"
        :variant="variant ? variant : primaryVariant"
        :class="(classOfButton ? classOfButton : primaryClassOfButton ) + (longSize ? ' button-max-long ' : ' size-button ')"
        :aria-disabled="focusAware && (disabled ?  disabled : primaryDisabled)"
        :disabled="!focusAware && (disabled ?  disabled : primaryDisabled)"
        :tabindex="0"
        @click.stop="clickOnButton"
        :style="buttonStyle + (showLabel ? '' : 'width:42px')"
    >
      <slot name="icon">
        <span :class="iconContainerClass">
        <font-awesome-icon :icon="icon ? icon : primaryIcon"
                           :class="iconClass ? iconClass : primaryIconClass"/></span>
      </slot>
      <span ref="label" :class="(labelClass ? labelClass : primaryLabelClass)" v-if="showLabel">
        {{ label ? label : primaryLabel }}
      </span>
    </b-button>
  </b-col>
</template>

<script>

import {
  OK_LABEL,
} from "@/components/navbar/ButtonLabel";

export default {
  name: "FooterButton",

  beforeMount() {
    this.checkType();
  },
  mounted() {
    if (this.smStyle === "link") {
      this.iconContainerClass = "d-none d-md-inline";
      this.primaryLabelClass = "px-0 px-sm-1 pt-0 pt-md-0";
      this.primaryClassOfButton = " px-2 px-sm-2 px-md-4";
    }
    const ss = this.$scopedSlots;
    const slotNodes = ss && ss['custom-icon'] && ss['custom-icon']();
    // this.hasCustomIcon = (slotNodes && slotNodes.length) || !!this.$slots['custom-icon'];
  },

  methods: {
    clickOnButton() {
      if (this.disabled ? this.disabled : this.primaryDisabled) {
        return;
      }
      this.$emit(_.kebabCase(this.type));
    },

    checkType() {
      switch (this.type) {
        case "Select":
          this.primaryLabel = $tr("Select", "Select");
          this.primaryVariant = "plm-success";
          this.primaryIcon = "hand-pointer";
          this.primaryDataTestPath = "select-button";
          break;
        case "Clear":
          this.primaryLabel = $tr("NoSelection", "No selection");
          this.primaryVariant = "plm-secondary";
          this.primaryIcon = "square-dashed";
          this.primaryDataTestPath = "clear-button";
          break;
        case "ReplaceDelete":
          this.primaryLabel = $tr("Replace", "Replace");
          this.primaryVariant = "plm-danger";
          this.primaryIcon = "recycle";
          this.primaryDataTestPath = "replace-button";
          break;
        case "Close":
          this.primaryLabel = $tr("Close", "Close");
          this.primaryVariant = "plm-tertiary";
          this.primaryIcon = "caret-left";
          this.primaryDataTestPath = "close-button";
          this.primaryIconClass = "fa-xl";
          break;
        case "Cancel":
          this.primaryLabel = $tr("Cancel", "Cancel");
          this.primaryVariant = "plm-tertiary";
          this.primaryIcon = "caret-left";
          this.primaryDataTestPath = "close-button";
          this.primaryIconClass = "fa-xl";
          break;
        case "Save":
          this.primaryLabel = $tr("Apply", "Apply");
          this.primaryVariant = "plm-save";
          this.primaryIcon = "save";
          this.primaryDataTestPath = "save-button";
          break;
        case "Open":
          this.primaryLabel = $tr("Open", "Open");
          this.primaryVariant = "plm-primary-light";
          this.primaryIcon = "envelope";
          this.primaryDataTestPath = "open-button";
          break;
        case "Import":
          this.primaryLabel = $tr("Import", "Import");
          this.primaryVariant = "plm-secondary";
          this.primaryIcon = "file-arrow-up";
          this.primaryDataTestPath = "import-button";
          break;
        case "Add":
          this.primaryLabel = $tr("add", "Add");
          this.primaryVariant = "plm-secondary";
          this.primaryIcon = "plus";
          this.primaryDataTestPath = "add-button";
          break;
        case "New":
          this.primaryLabel = $tr("FooterButtom.new", "New");
          this.primaryVariant = "plm-success";
          this.primaryIcon = "sparkles";
          this.primaryDataTestPath = "add-button";
          break;
        case "Edit":
          this.primaryLabel = $tr("Edit", "Edit");
          this.primaryVariant = "plm-secondary";
          this.primaryIcon = "pencil-alt";
          this.primaryDataTestPath = "edit-button";
          break;
        case "Delete":
          this.primaryLabel = $tr("Delete", "Delete");
          this.primaryVariant = "plm-danger";
          this.primaryIcon = "trash";
          this.primaryDataTestPath = "delete-button";
          break;
        case "Details":
          this.primaryLabel = $tr("Details", "Details");
          this.primaryVariant = "plm-primary";
          this.primaryIcon = "pencil-alt";
          this.primaryDataTestPath = "details-button";
          break;
        case "Ok":
          this.primaryLabel = OK_LABEL;
          this.primaryVariant = "plm-primary-light";
          this.primaryIcon = "check";
          this.primaryDataTestPath = "ok-button";
          break;
        case "NavigateLeft":
          this.primaryVariant = "plm-secondary";
          this.primaryIcon = "angle-double-left";
          this.primaryClassOfButton = "button-arrow-width";
          this.primaryDataTestPath = "arrow-left-button";
          this.primaryLabelClass = "";
          break;
        case "NavigateRight":
          this.primaryVariant = "plm-secondary";
          this.primaryIcon = "angle-double-right";
          this.primaryClassOfButton = "button-arrow-width";
          this.primaryDataTestPath = "arrow-right-button";
          this.primaryLabelClass = "";
          break;
        case "Generate":
          this.primaryLabel = $tr("Generate-button", "Generate");
          this.primaryVariant = "plm-secondary";
          this.primaryIcon = "fa-solid fa-rotate";
          this.primaryDataTestPath = "generate-button";
          break;
      }

      this.primaryDefaultClassOfButton = this.primaryClassOfButton;
    }
  },

  props: {
    type: {type: String, default: ""},
    label: {type: String, default: ""},
    icon: {type: String, default: ""},
    labelClass: {type: String, default: ""},
    dataTestPath: {type: String, default: ""},
    variant: {type: String, default: ""},
    classOfButton: {type: String, default: null},
    disabled: {type: Boolean, default: false},
    iconClass: {type: String, default: ""},
    buttonStyle: {type: String, default: ""},
    smStyle: {type: String, default: "icon-button"}, // link | icon-button
    labelBreakPoint: {type: String, default: "md"},
    longSize: {default: false},
    showLabel: {default: true},
    focusAware: {default: false},

  },

  watch: {
    type: function () {
      this.checkType();
    },
  },

  data: function () {
    return {
      //   hasCustomIcon: false,
      primaryLabel: "",
      primaryIcon: "",
      primaryLabelClass: `d-none d-${this.labelBreakPoint}-inline pl-1`,
      primaryDataTestPath: "",
      primaryVariant: "",
      primaryClassOfButton: `size-button-${this.labelBreakPoint}`,
      primaryDefaultClassOfButton: `size-button-${this.labelBreakPoint}`,
      primaryDisabled: false,
      primaryIconClass: "",

      iconContainerClass: "",
      SAVE_LABEL: $tr("Apply", "Apply"),
      OPEN_LABEL: $tr("Open", "Open"),
      ADD_LABEL: $tr("add", "Add"),
      EDIT_LABEL: $tr("Edit", "Edit"),
      DELETE_LABEL: $tr("Delete", "Delete"),
      DETAILS_LABEL: $tr("Details", "Details"),
      OK_LABEL: $tr("OK", "OK")
    }
  }

}
</script>